package com.milta.core.localization.translations.bg

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 нелокализиран адрес",
    warningTitlePlural = "Нелокализирани адреси: %d",
    warningMessage = "Тези доставки не можаха да бъдат поставени на картата. Коригирайте адреса им или продължете: те ще бъдат сложени в края на маршрута.",
    fixAction = "Коригирай",
    continueWithoutAction = "Продължи без тях",
    unplacedStopsSingular = "1 непоставена спирка, в края на маршрута",
    unplacedStopsPlural = "Непоставени спирки: %d, в края на маршрута",
    fixAddressAction = "Коригирай адреса",
    unlocatedBadge = "Нелокализиран",
)
